module.exports = __webpack_public_path__ + "static/img/widget-bar.cbd72be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/widget-bar.png
// module id = 5G43
// module chunks = 1